import React from 'react';

type Props = {
  children: React.ReactNode;
  index: any;
  value: any;
};

const TabPanel: React.FC<Props> = ({ index, value, children }) => {
  return (
    <div role="tabpanel" hidden={value !== index} id={`full-width-tabpanel-${index}`} aria-labelledby={`full-width-tab-${index}`}>
      {children}
    </div>
  );
};

export default TabPanel;
